const locationReload = () => window.location.reload();

export default locationReload;
